import React from 'react'
import Header from '../../components/Header'
import Navbar from './Navbar'
import { Outlet } from 'react-router-dom'
import './index.css'
import Footer from '../../components/Footer'

export default function AdminPanel() {
	return (
		<div>
			<div id='mainFlexContainer'>
				<Header />
				<div id='contentContainer'>
					<Navbar />
					<div id='mainContentContainer'>
						<Outlet />
					</div>
				</div>
				<Footer />
			</div>
		</div>
	)
}
